export function getModalContainer(): HTMLElement | null {
  return document.querySelector('[data-slot="modal-content"]') as HTMLElement | null;
}
